import { Injectable } from '@angular/core';
import { QuoteErrorTypeEnum } from '../enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorUtil {
  static async handleError(httpError): Promise<never> {
    const errorResponse = httpError?.response;
    if (!errorResponse) {
      return Promise.reject(httpError);
    }
    const responseBodyStr = errorResponse.body;
    let responseBody: any;
    try {
      responseBody = JSON.parse(responseBodyStr);
    } catch {
      responseBody = responseBodyStr;
    }
    
    const errorMessage = ErrorUtil.constructErrorMessage(errorResponse.status, responseBody);
    console.error(errorMessage);
    return Promise.reject(responseBody);
  }

  static async warnError(httpError): Promise<void> {
    const errorResponse = httpError?.response;
    if (!errorResponse) {
      return Promise.resolve();
    }
    const responseBodyStr = errorResponse.body;
    let responseBody: any;
    try {
      responseBody = JSON.parse(responseBodyStr);
    } catch {
      responseBody = responseBodyStr;
    }
    const errorMessage = ErrorUtil.constructErrorMessage(errorResponse.status, responseBody);
    console.warn(errorMessage);
    return Promise.resolve();
  }

  private static constructErrorMessage(responseStatus: number, responseBody: any): string {
    const errDetails: string[] = [`Status: ${responseStatus}`];

    if (responseBody?.fieldErrors) {
      if (Array.isArray(responseBody.fieldErrors)) {
        return responseBody.fieldErrors.join(', ');
      } else if (typeof responseBody.fieldErrors === 'object') {
        return JSON.stringify(responseBody.fieldErrors);
      }
    }

    if (responseBody?.error) {
      errDetails.push(`Error: ${responseBody.error}`);
    }

    return errDetails.join(' | ');
  }

  static buildApiErrorMessage(type, message) {
    let title = '',
      text = '',
      spanMessage = '',
      footText = '',
      confirmBtnText = $localize`:@@shipment-details.zero-awb-stock.provid-awb: PROVIDE AWB`;
    switch (type) {
      case QuoteErrorTypeEnum.AWB_NOT_AVAILABLE:
        title = $localize`:@@shipment-details.zero-awb-stock.title:ZERO AWB STOCK ALERT`;
        text = $localize`:@@shipment-details.zero-awb-stock.awb-stock-empty: Looks like AWB stock is empty.`;
        spanMessage = $localize`:@@shipment-details.zero-awb-stock.not-to-worry: Not to worry, as we have already notified the airline and it should be solved soon!`;
        footText = $localize`:@@shipment-details.zero-awb-stock.use-your-own-awb: USE YOUR OWN AWB NUMBER TO PROCEED WITH THIS BOOKING`;
        break;
      case QuoteErrorTypeEnum.AWB_ALREADY_USED:
        title = $localize`:@@shipment-details.awb-already-used.title:AWB ALREADY USED`;
        text = $localize`:@@shipment-details.zero-awb-stock.awb-already-used: Looks like the AWB you chose is already in use.`;
        footText = $localize`:@@shipment-details.zero-awb-stock.use-another-awb: USE ANOTHER AWB NUMBER TO PROCEED WITH THIS BOOKING`;
        break;
      case QuoteErrorTypeEnum.AWB_NOT_PART_OF_STOCK:
        title = $localize`:@@shipment-details.invalid-awb-stock.title:INCORRECT AWB STOCK`;
        text = $localize`:@@shipment-details.invalid-awb-stock.awb-invalid-stock: The provided AWB doesn't seems to belong to your stock.`;
        footText = $localize`:@@shipment-details.invalid-awb-stock.contact-the-airline: Please contact the airline to verify your AWB list`;
        break;
      case QuoteErrorTypeEnum.THIRD_PARTY_ERROR:
        title = $localize`:@@shipment-details.third-party-error.title: AIRLINE API ERROR`;
        text = $localize`:@@shipment-details.third-party-error.airline-api-error-description: Something wrong happened while sending your request to airline's API.`;
        spanMessage = message;
        footText = $localize`:@@shipment-details.third-party-error.airline-api-error-try-again: Try again or contact CAI support`;
        confirmBtnText = $localize`:@@shipment-details.third-party-error.confirm: Confirm`;
        break;
      default:
        console.warn('Handle fatal error');
        return;
    }
    return { title, text, spanMessage, footText, confirmBtnText };
  }
}
